import { STEP_IDS, type WizardState, type WizardAction } from './types';
import { isStepValid, nextStep, previousStep } from './selectors';

export const INITIAL_STATE: WizardState = {
  currentStep: 'place',
  draft: {
    selectedPlace: null,
    producerName: '',
    offerings: [],
    contactEmail: '',
  },
  hydrated: false,
};

export function wizardReducer(state: WizardState, action: WizardAction): WizardState {
  switch (action.type) {
    case 'HYDRATE': {
      const draft = {
        selectedPlace: action.draft.selectedPlace ?? state.draft.selectedPlace,
        producerName: action.draft.producerName ?? state.draft.producerName,
        offerings: action.draft.offerings ?? state.draft.offerings,
        contactEmail: action.draft.contactEmail ?? state.draft.contactEmail,
      };
      // Validate requested step — fall back to first if invalid
      let step = action.step ?? state.currentStep;
      if (!STEP_IDS.includes(step)) step = 'place';
      return { currentStep: step, draft, hydrated: true };
    }

    case 'SET_SELECTED_PLACE':
      return {
        ...state,
        draft: { ...state.draft, selectedPlace: action.place },
      };

    case 'SET_PRODUCER_NAME':
      return {
        ...state,
        draft: { ...state.draft, producerName: action.name },
      };

    case 'SET_OFFERINGS':
      return {
        ...state,
        draft: { ...state.draft, offerings: action.offerings },
      };

    case 'SET_CONTACT_EMAIL':
      return {
        ...state,
        draft: { ...state.draft, contactEmail: action.email },
      };

    case 'GO_NEXT': {
      if (!isStepValid(state, state.currentStep)) return state;
      const next = nextStep(state);
      if (!next) return state; // already last — caller handles submit
      return { ...state, currentStep: next };
    }

    case 'GO_BACK': {
      const prev = previousStep(state);
      if (!prev) return state; // already first — caller handles exit
      return { ...state, currentStep: prev };
    }

    case 'GO_TO_STEP': {
      if (STEP_IDS.includes(action.step)) {
        return { ...state, currentStep: action.step };
      }
      return state;
    }

    default:
      return state;
  }
}
